import { AlertSentenceContext } from 'components/ChartAlert/Contexts/AlertSentenceContext';
import React, { useMemo, useState } from 'react';

type Props = {
    children: JSX.Element;
};

const AlertSentenceProvider = ({ children }: Props): JSX.Element => {
    const [availableMetrics, setAvailableMetrics] = useState<
        AvailableMetricT[] | null
    >(null);
    const [availableDimensions, setAvailableDimensions] = useState<
        AvailableDimensionT[] | null
    >(null);
    const [availableFilters, setAvailableFilters] = useState<
        AvailableElementT[] | null
    >(null);

    const alertSentenceState = useMemo(
        () => ({
            availableMetrics,
            setAvailableMetrics,
            availableDimensions,
            setAvailableDimensions,
            availableFilters,
            setAvailableFilters,
        }),
        [
            availableMetrics,
            setAvailableMetrics,
            availableDimensions,
            setAvailableDimensions,
            availableFilters,
            setAvailableFilters,
        ],
    );

    return (
        <AlertSentenceContext.Provider value={alertSentenceState}>
            {children}
        </AlertSentenceContext.Provider>
    );
};

export default AlertSentenceProvider;
